<div class="responsive-card gap-4">
  <div i18n class="responsive-card-title">Withdrawal Instructions</div>
  <div *ngIf="!hasChanges" i18n class="subtitle">
    The payments will be made with the withdrawal percentages outlined below
  </div>

  <ng-container *ngIf="!hasChanges; else comparisonView">
    <ng-container *ngTemplateOutlet="fundsGrid; context: { instructions: displayInstructions }" />
  </ng-container>

  <ng-template #comparisonView>
    <div class="d-flex flex-column gap-3">
      <span class="label-sm" i18n>Current</span>
      <div class="comparison-container current">
        <ng-container *ngTemplateOutlet="fundsGrid; context: { instructions: currentInstructions }" />
      </div>
    </div>
    <div class="d-flex flex-column gap-3">
      <span class="label-sm" i18n>New</span>
      <div class="comparison-container new">
        <ng-container *ngTemplateOutlet="fundsGrid; context: { instructions: newInstructions }" />
      </div>
    </div>
  </ng-template>
</div>

<ng-template #fundsGrid let-instructions="instructions">
  <div class="funds-grid">
    <div *ngFor="let instruction of instructions; trackBy: trackByIndex" class="inner-card d-flex flex-column">
      <div class="fund-indicator" aria-hidden="true" [style.background-color]="instruction.fund?.colour"></div>
      <div class="d-flex flex-column gap-2">
        <div class="fund-name">{{ instruction.fund?.name }}</div>
        <div class="paragraph-lg">{{ instruction.percentage | number : '1.2-2' }}%</div>
      </div>
    </div>
  </div>
</ng-template>
